import { Menu } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { IconFigmaClockS, IconFigmaDocument, IconFigmaFile } from '@/assets/icons';
import { KebabTrigger } from '@/components/common/KebabTrigger';

interface RowActionsMenuProps {
  detailsHref: string;
  /** Opcionalno — izostavljeno na entitetima bez AUD-01/AUD-02 povijesti statusa (npr. Cjenici). */
  historyHref?: string;
  /** Opcionalno — "Pregledaj" PDF akcija (isti handler kao na detalju, openBinaryInNewTab).
   * Prosljeđuje se samo s onih lista čiji entitet ima PDF (Ponude, Ugovori) — izostavljeno,
   * stavka se jednostavno ne prikazuje (npr. Radni paketi, Aktivnosti, Tjedni izvještaji). */
  onPreview?: () => void;
}

/** AUD-01/AUD-02 — zamjenjuje "Detalji" link na top-level listama (Ponude/Ugovori/Radni paketi/
 * Aktivnosti/Tjedni izvještaji/Fakture): kebab s opcijama Detalji (postojeće ponašanje), opcionalno
 * Pregledaj (PDF) i Povijest (novi ekran povijesti statusa). Isti KebabTrigger kao svi ostali
 * akcijski izbornici reda (stavke Cjenika, Jedinice, Timovi, linije Ponude) — jedna dijeljena
 * komponenta, ne duplicirani stil po datoteci. */
export const RowActionsMenu = ({ detailsHref, historyHref, onPreview }: RowActionsMenuProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Menu position="bottom-end" withinPortal shadow="md" radius="md" width={200}>
      <Menu.Target>
        <KebabTrigger onClick={(event) => event.stopPropagation()} />
      </Menu.Target>
      <Menu.Dropdown onClick={(event) => event.stopPropagation()}>
        <Menu.Item
          leftSection={<IconFigmaDocument size={14} />}
          styles={{ item: { color: 'var(--color-text-primary)' } }}
          onClick={() => navigate(detailsHref)}
        >
          {t('common.rowActions.details')}
        </Menu.Item>
        {onPreview && (
          <Menu.Item
            leftSection={<IconFigmaFile size={14} />}
            styles={{ item: { color: 'var(--color-text-primary)' } }}
            onClick={onPreview}
          >
            {t('common.rowActions.preview')}
          </Menu.Item>
        )}
        {historyHref && (
          <Menu.Item
            leftSection={<IconFigmaClockS size={14} />}
            styles={{ item: { color: 'var(--color-text-primary)' } }}
            onClick={() => navigate(historyHref)}
          >
            {t('common.rowActions.history')}
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
};
